import { CartLinePriceFragment } from '@graphql/fragments/__generated__/CartLinePrice.generated'
import { FullCartQueryResult } from '@graphql/queries/__generated__/cart.generated'
import React, { useMemo } from 'react'
import { PromoCodeFragment } from '@graphql/fragments/__generated__/PromoCode.generated'
import { calculatePromoCodeApplied } from '../../../utils/cart'
import FormattedPrice from '@components/FormattedPrice'

interface CartLinePriceProps {
  line?: FullCartQueryResult['data']['cart']['allLines'][0]
  part?: FullCartQueryResult['data']['cart']['allLines'][0]['supplyParts'][0]
  qty: number
  promoCode?: PromoCodeFragment
  isWholesaleMode?: boolean
}

const CartLinePrice: React.FC<CartLinePriceProps> = ({ line, qty, part, promoCode, isWholesaleMode }) => {
  const linePrice: CartLinePriceFragment | null = useMemo(() => {
    if (line) {
      if (!line.supplyParts.length) {
        return line.unitPrice
      } else {
        return line.supplyParts.reduce(
          (prev, curr) => {
            return {
              currency: curr.unitPrice.currency,
              discount: prev.discount + curr.unitPrice.discount * curr.quantity,
              undiscount: prev.undiscount + curr.unitPrice.undiscount * curr.quantity,
            }
          },
          { currency: '', discount: 0, undiscount: 0 }
        )
      }
    }
    if (part) {
      return part.unitPrice
    }
    return null
  }, [line, part])
  if (!linePrice) return null
  if (isWholesaleMode) {
    return (
      <FormattedPrice
        amount={line.variant.wholesalePrice.undiscount * qty}
        currency={line.variant.wholesalePrice.currency}
      />
    )
  }
  const isSale = linePrice.discount !== linePrice.undiscount
  const promoCodeApplied = line && promoCode?.availability ? calculatePromoCodeApplied(promoCode, [line]) : 0
  return (
    <>
      <span className={isSale || promoCodeApplied ? 'line-through' : ''}>
        <FormattedPrice amount={linePrice.undiscount * qty} currency={linePrice.currency} />
      </span>
      {isSale && (
        <span className={`text-red ${!!promoCodeApplied ? 'line-through' : ''}`}>
          {' '}
          <FormattedPrice amount={linePrice.discount * qty} currency={linePrice.currency} />
        </span>
      )}
      {!!promoCodeApplied && (
        <span className='text-red'>
          {' '}
          <FormattedPrice amount={linePrice.discount * qty - promoCodeApplied} currency={linePrice.currency} />
        </span>
      )}
    </>
  )
}

export default CartLinePrice
